let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("liQTV")).then(() => parcelRequire('3faZa'));